import { configureStore , combineReducers} from "@reduxjs/toolkit";
import presurveyReducer from "../redux/slices/presurveySlice";
import supplierFormReducer from "../redux/slices/supplierFormSlice";
import goalsReducer from "../redux/slices/supplierGoalsSlice";
import themeReducer from "../redux/slices/themeSlice";
import energyReducer from "./reducers/reducer";
import { cdpReducer } from "./reducers/cdpReducer";
import reportReducer from "../redux/slices/supplierReportingSlice";
import supplierSearchSlice from "./slices/supplierSearchSlice";
import signupSlice from "./slices/signupSlice";
import userPermissionsReducer from "./slices/userPermissionsSlice"
import entityReducer from "./slices/entitySlice"
import {subAppOnboardingReducer} from '../gitsubmodules/onboarding/src/redux/store'; // SubApp’s reducer
import dashboardSlice from "./slices/dashboardSlice";


const store = configureStore({
  reducer: {
    presurvey: presurveyReducer,
    supplier: supplierFormReducer,
    cdp: cdpReducer,
    energy: energyReducer,
    goals: goalsReducer,
    theme: themeReducer,
    reporting: reportReducer,
    supplierSearch: supplierSearchSlice,
    signup:signupSlice,
    dashboard:dashboardSlice,
    userPermission:userPermissionsReducer,
    entity: entityReducer,
    ...subAppOnboardingReducer
  },
});



export default store;
